import React, { useRef } from 'react';
import { FiAlertCircle } from 'react-icons/fi';
import Modal from '../shared/Modal';

const DeleteCustomTabModal = ({ open, onClose, tab, onConfirm }) => {
    const cancelRef = useRef(null);
    const confirmRef = useRef(null);

    if (!open || !tab) return null;

    // Modal actions
    const modalActions = (
        <>
            <button
                ref={cancelRef}
                onClick={onClose}
                className="flex-1 px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-lg transition"
            >
                Annuler
            </button>
            <button
                ref={confirmRef}
                onClick={onConfirm}
                className="flex-1 px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition"
            >
                Supprimer l'onglet
            </button>
        </>
    );

    return (
        <Modal
            open={open}
            onClose={onClose}
            title="Supprimer l'onglet personnalisé"
            actions={modalActions}
            initialFocusRef={confirmRef}
        >
            <div className="mb-4 min-w-0">
                <p className="text-gray-600 dark:text-gray-300 mb-3">
                    Êtes-vous sûr de vouloir supprimer l'onglet suivant ?
                </p>

                {/* Aperçu de l'onglet */}
                <div className="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg border min-w-0 overflow-hidden">
                    <div className="flex items-center gap-2 min-w-0 w-full">
                        <div
                            className="w-4 h-4 rounded-full flex-shrink-0"
                            style={{ backgroundColor: tab.color }}
                        />
                        <span
                            className="font-medium text-gray-900 dark:text-white truncate flex-1 min-w-0 block overflow-hidden"
                            title={tab.name}
                            style={{ maxWidth: '200px' }}
                        >
                            {tab.name}
                        </span>
                        <span className="text-sm text-gray-500 dark:text-gray-400 flex-shrink-0 ml-2 whitespace-nowrap">
                            ({tab.messageIds?.length || 0} {tab.messageIds?.length === 1 ? 'message' : 'messages'})
                        </span>
                    </div>
                </div>

                <div className="mt-3 p-3 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-700 rounded-lg">
                    <div className="flex gap-2">
                        <FiAlertCircle className="w-4 h-4 text-amber-600 dark:text-amber-400 mt-0.5 flex-shrink-0" />
                        <div className="text-sm text-amber-700 dark:text-amber-300">
                            <p className="font-medium mb-1">Attention :</p>
                            <p>
                                Cette action supprimera définitivement l'onglet et retirera tous les messages qui y sont organisés.
                                Les messages ne seront pas supprimés, ils redeviendront simplement non classés.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default DeleteCustomTabModal;